module.exports = __webpack_public_path__ + "assets/img/d65094f7e9c65ad082fa9709f206c918.svg";